<template>
  <v-form ref="menu-form" id="menu-form" v-model="isMenuFormValid">
    <CartDateControls v-if="getEnableItemDates" :sections="sections" />
    <SectionNavigator :sections="sectionsWithSortedItems.map((s) => s.name)" />
    <template v-if="numVisibleItems">
      <MenuSection
        v-for="(section, i) of sectionsWithSortedItems"
        :key="section.id"
        :section="section"
        :index="i"
      />
    </template>
    <div v-else class="text-center">
      <h2
        >No Items Available
        <span v-if="searchDate && getEnableItemDates">for This Date</span></h2
      >
      <div v-if="searchDate && getEnableItemDates"
        >Either select a calendar date with a green dot or use the arrows to
        select the nearest date in the past or future.
      </div>
      <div v-else>Please check back again soon.</div>
    </div>
  </v-form>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

import _sortBy from 'lodash/sortBy'
import _reduce from 'lodash/reduce'

import MenuSection from '@/components/MenuSection'
import SectionNavigator from '@/components/SectionNavigator'
import CartDateControls from '@/components/CartDateControls'

export default {
  name: 'MenuForm',
  components: { MenuSection, SectionNavigator, CartDateControls },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapFields('cart', ['isMenuFormValid', 'searchDate']),
    ...mapGetters('shop', [
      'getEnableItemDates',
      'getLeadTimeMinutes',
      'getTimezone',
    ]),
    sectionsFilteredByLeadTime() {
      // Filter and transform the items in the sections array
      return this.sections.map((section) => {
        return {
          ...section,
          items: section.items
            // Keep only items whose date is not set or is greater than or equal to nowPlusLeadTimeUtc
            .filter((item) => {
              return !item.date || (item.date && !item.is_too_late_to_order)
            })
            // Convert the date of each item from UTC to the timezone specified by getTimezone
            .map((item) => {
              return {
                ...item,
                date: item.date,
              }
            }),
        }
      })
    }, // sectionsFilteredByLeadTime

    sectionsWithSortedItems() {
      let sectionsToSort = this.getEnableItemDates
        ? this.sectionsFilteredByLeadTime
        : this.sections
      let sortedSections = _sortBy(sectionsToSort, 'order')
      let itemFilterFunction = (item) => !item.hidden
      if (this.searchDate) {
        itemFilterFunction = (item) =>
          !item.hidden && item.date == this.searchDate
      }

      return sortedSections
        .map((s) => {
          return {
            ...s,
            items: _sortBy(s.items, 'order').filter(itemFilterFunction),
          }
        })
        .filter((section) => section.items.length)
    }, // sortedItems
    numVisibleItems() {
      return _reduce(
        this.sectionsWithSortedItems,
        (sum, section) => sum + section.items.length,
        0
      )
    }, // numVisibleItems
  },
}
</script>
